import { render } from "./MMainButtonSettingEditModal.vue?vue&type=template&id=4c6f1224&scoped=true&ts=true"
import script from "./MMainButtonSettingEditModal.vue?vue&type=script&lang=ts"
export * from "./MMainButtonSettingEditModal.vue?vue&type=script&lang=ts"

import "./MMainButtonSettingEditModal.vue?vue&type=style&index=0&id=4c6f1224&lang=scss&scoped=true"

import exportComponent from "/Users/kameyamanaoki/dev/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c6f1224"]])

export default __exports__